import { PipelineAttemptsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { adminDashboardKeys } from 'app/queries/adminDashboard/adminDashboardKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminDashboardKeys.processingJobList>>;

export const createFetchProcessingJobsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        PipelineAttemptsService.getLongestProcessingJobs({
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
        }),
        signal,
      ),
    );
